<template>
  <v-container>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
    >
      <v-row class="justify-content-md-left px-3">
        <v-col cols="12">
          <p class="text-left mb-0 label ml-2">срок хранения:</p>
          <v-btn-toggle mandatory dense v-model="storagePeriod">
            <template v-for="(p, ind) in avPeriodsService">
              <v-btn
                  :key="'btn-mes-' + ind"
                  @click="chosenItemId = p.id"
              >
                {{ p.params.period }} {{ morph(p.params.period) }}
              </v-btn>
            </template>
          </v-btn-toggle>
        </v-col>
        <v-col md="auto" cols="3" v-on-clickaway="blurNumpad">
          <v-text-field
              label="Пломба"
              data-test-id="seal"
              v-model="seal"
              :rules="sealRules"
              v-mask="'######'"
              @focus="focusedOnNumpad=true"
              required
              ref="seal"
          />
          <!--keyboard v-if="focusedOnNumpad"
                    v-model="seal"
                    :layouts="[
                              '123|456|789|0{delete:backspace}'
                          ]"
                    :maxlength="16"
                    class="card p-3 numpad"
          ></keyboard-->
        </v-col>
        <v-col md="auto" cols="3">
          <v-text-field
              label="Гос. номер"
              pattern="'/^[A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9]$/'"
              :rules="licensePlateRules"
              v-model="licensePlate"
              data-test-id="licensePlate"
              @focus="focusedOnNumpad=true"
              required
              ref="licensePlate"
          />
        </v-col>
      </v-row>
      <v-row class="justify-content-md-left px-3">
        <v-col md="auto" cols="3">
          <v-text-field
              label="Имя клиента"
              v-model="storeName"
              :rules="nameRules"
              required
              ref="storeName"
              clearable
              data-test-id="inputNameForSeasonStorage"
          />
        </v-col>
        <v-col md="auto" col="3">
          <v-text-field
              data-test-id="inputLastNameForSeasonStorage"
              label="Фамилия клиента"
              v-model="storeFamily"
              :rules="nameRules"
              required
              ref="storeFamily"
              clearable
          />
        </v-col>
        <v-col md="auto" col="4">
          <v-text-field
              data-test-id="phoneForSeasonStorage"
              v-model="storePhone"
              v-mask="'+7(###) ###-##-##'"
              label="Телефон"
              name="phoneNumber"
              :rules="phoneNumber"
              required
              ref="storePhone"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <ChooseOfWheels v-model="wheels" />
          <v-text-field
              v-model="filter"
              label="Модель и марка"
              name="car"
              :rules="nameRules"
              ref="filter"
              @click="show"
              @input="check()"
              @blur="checkFilter"
              autocomplete="off"
          />

          <v-dialog
              v-model="carModelSSModal"
              width="900px"
          >
            <v-card>
              <div class="p-4" style="background-color: #C9C9C7; height: auto; overflow-y: auto;">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="filter"
                        label="Модель"
                        name="car"
                        autofocus
                        ref="filterInner"
                        @input="check()"
                        @blur="checkFilter"
                        outlined
                        autocomplete="off"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <cards-grid
                      v-if="carModelSSModal"
                      :chosenMark="chosenMark"
                      :chosenModel="chosenModel"
                      :items="chosenMark ? carsModels : carMarksFiltred"
                      :showAllMarks="showAllMarks"
                      @changeAllMarks="showAllMarks = $event"
                      @clearMark="clearMark"
                      @hide="carModelSSModal = false"
                      @chooseItem="chooseCarItem($event)"
                  />
                </v-row>
              </div>
            </v-card>
            <!--                                   <v-col>-->
            <!--                                        <v-text-field-->
            <!--                                            v-model="filter"-->
            <!--                                            label="Модель"-->
            <!--                                            name="car"-->
            <!--                                            autofocus-->
            <!--                                            ref="filterInner"-->
            <!--                                            @input="check()"-->
            <!--                                            @blur="checkFilter"-->
            <!--                                            outlined-->
            <!--                                            autocomplete="off"-->
            <!--                                        />-->
            <!--                                    </v-col>-->
            <!--                                </v-row>-->

            <!--                                <h5 class="modal-title p-4 d-inline-block">Выберите марку автомобиля: {{ chosenMark }} {{ chosenModel }}</h5>-->
            <!--                                <template v-if="chosenMark">-->
            <!--                                    <button class="btn btn-success btn-sm pr-2 carmark btn btn-options__marks__icon" @click="clearMark">Выбрать другую</button>-->
            <!--                                </template>-->
            <!--                                <div class="d-flex flex-wrap justify-content-around" v-if="!chosenModel">-->
            <!--                                    <template v-for="(item, index) in carMarksFiltred">-->
            <!--                                        <v-btn-->
            <!--                                            tile-->
            <!--                                            class="carmark ma-2 rounded "-->
            <!--                                            @click="[loadModels(item.mark), hide()]"-->
            <!--                                            :key="'carMarks-' + index"-->
            <!--                                        >-->
            <!--                                            <v-img-->
            <!--                                                v-if="item.image"-->
            <!--                                                :src="'/' + item.image"-->
            <!--                                                height="25"-->
            <!--                                                width="25"-->
            <!--                                                max-width="30"-->
            <!--                                                style="margin-right: 3px;" />-->
            <!--                                            {{item.mark}}-->
            <!--                                        </v-btn>-->
            <!--                                    </template>-->
            <!--                                </div>-->
            <!--                                &lt;!&ndash;div class="d-flex flex-wrap justify-content-around" v-if="chosenMark && carModelsFiltred">-->
            <!--                                    <template v-for="item in carModelsFiltred">-->
            <!--                                        <v-btn tile class="btn btn-sm pr-2 carmark btn btn-options__marks__icon" @click.prepend="[setCarType([item.car_type_id, item.model]), hide()]">-->
            <!--                                            {{item.model}}-->
            <!--                                        </v-btn>-->
            <!--                                    </template>-->
            <!--                                </div&ndash;&gt;-->
            <!--                            </div>-->
            <!--                        </v-card>-->
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="9">
          <v-card flat>
            <v-tabs
                v-model="tab"
            >
              <v-tab
                  v-for="item in tabs"
                  :key="item.key"
                  @click="isFirstTab = false"
              >
                <v-img :src="icon[item.icon]" aspect-ratio="2" contain class="tabs_icons"></v-img>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                  v-for="item in tabs"
                  :key="item.key"
              >
                <v-card flat class="main_bg_color">
                  <v-card-text class="pt-1 pb-0">
                    <tire-form ref="TireForm" :side="item.key"/>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="9" class="result-text">
          <p v-for="(item,index) in getTotalWheelsInfo(showActive)" :key="index">
            {{ '[' + item.item.side + '] ' + item.text }}
          </p>
        </v-col>
        <v-col cols="12" sm="3" class="pt-0">
          <div class="price mb-3">
                                            <span class="fullprice" v-if="discount>0">
                                                {{numberWithSpaces(totalPriceFull)}} ₽
                                            </span>
            <span class="discount" v-if="discount>0">
                                                -{{ discount }}%
                                            </span>
            <span class="discountprice">
                                                {{numberWithSpaces(totalPriceFull)}} ₽
                                            </span>
          </div>
          <v-btn large color="#C8FA92" data-test-id="addDisk" block @click="addServiceToCart">
            Добавить
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

  </v-container>
</template>

<script>
// @ is an alias to /src
import ChooseOfWheels from './ChooseOfWheels'
import TireForm from "./TireForm"
import { directive as onClickaway } from 'vue-clickaway';
// import keyboard from 'vue-keyboard';
import {mapGetters} from 'vuex'
import * as _ from "core-js";

const inputsRef = [
  'storePhone',
  'storeFamily',
  'storeName',
  'licensePlate',
  'seal',
  'filter'
];
const tireFormInputsRef = [
  'tireHeightSelect',
  'tireMarkSelect',
  'tireProfileSelect',
  'tireStateSelect',
  'tireWidthSelect',
]

export default {
  props: ['itemID'],
  components: {
    ChooseOfWheels,
    TireForm,
    cardsGrid: () => import("../order/carsModelsMarks.vue"),
    // keyboard
  },
  directives: {
    onClickaway: onClickaway,
  },
  watch: {
    errors: {
      handler: function() {
        _.forEach(this.rules, (val, key) => {
          this.rules[key] = [() => (this.errors.has(key) ? this.errors.first(key) : true)];
        });
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters([
      "carMarks",
      "carModels",
      "clientCars",
      "clientType",
      "carMarksModels",
      "carTypesByService",
    ]),
    carsModels() {
      return this.showAllMarks ? this.carModels : this.carModelsFiltred
    },
    avPeriodsService () {
      const avb = this.$store.getters.services.filter(item => item.calc_type === 'SeasonalStorageCalc' )
      const periods = []
      avb.forEach((v) => {
        periods.push({
          id: v.id,
          price: v.price,
          params: JSON.parse(v.params)
        })
      })
      periods.sort((a,b) => a.params.period - b.params.period);
      return periods
    },
    carMarksFiltred () {
      let carMarks = []
      let carMarksModel = []
      if (this.filter.length > 0 && this.carMarks && this.carMarks.length > 0) {
        let filter = this.filter
        filter = filter.replace(/ +/g, ' ').trim()
        filter = filter.split(' ')
        if (filter[0].length > 0) {
          if (!this.chosenMark) {
            this.carMarks.forEach((x)=>{
              let change = this.changeLetters(filter[0])
              let changeEtR = this.changeLettersEtR(filter[0])
              console.log('model find', x)
              if ( ~x.name.toLowerCase().indexOf(change.toLowerCase()) ||
                  (x.nameRus && ~x.nameRus.toLowerCase().indexOf(filter[0].toLowerCase())) ||
                  (x.nameRus && ~x.nameRus.toLowerCase().indexOf(changeEtR.toLowerCase()))
                  // (x.model && ~x.model.toLowerCase().indexOf(filter[0].toLowerCase()))
              ) {
                let noOne = true
                carMarks.forEach(z=>{
                  if (z.name === x.name) {
                    noOne = false
                  }
                })
                if (noOne) carMarks.push(x)
              }
            })
          } else {
            this.carMarksModels.forEach((x)=>{
              if (x.name && ~x.name.toLowerCase().indexOf(filter[0].toLowerCase())) {
                const toSave = JSON.parse(JSON.stringify(x))
                toSave.carMarkModel = toSave.mark.name + ' | ' + toSave.name
                carMarks.push(toSave)
                carMarksModel.push(toSave)
              }
            })
          }
        }
      }  else if (this.carMarks && this.carMarks.length > 0) {
        this.carMarks.forEach((x)=>{
          if (x.popular || this.showAllMarks) {
            carMarks.push(x)
          }
        })
      } else {
        carMarks = this.carMarks
      }
      if (carMarksModel.length > 0) {
        return [...carMarks, ...carMarksModel]
      }
      return carMarks
    },
    carModelsFiltred () {
      let carModels = []
      if(this.chosenMark && this.filter.length > 2 && this.carModels.length > 0){
        carModels = this.carModels
        let filter = this.filter
        filter = filter.replace(this.chosenMark, '')
        filter = filter.replace(' ', '').trim()
        if (this.carModels.length > 0 && filter ) {
          carModels = []
          this.carModels.forEach((x)=>{
            let change = this.changeLetters(filter)
            if(x.model && x.model.toLowerCase().indexOf(change.toLowerCase()) > -1 || (x.model_transliteration && x.model_transliteration.toLowerCase().indexOf(filter.toLowerCase()) > -1)) {
              carModels.push(x)
            }
          })
        } else {
          carModels = []
          this.carModels.forEach((x)=>{
            if(x.is_popular) {
              carModels.push(x)
            }
          })
          if(carModels.length===0) {
            carModels = this.carModels
          }
        }
      }
      return carModels
    },
    filtrCarTypes () {
      if (this.carTypes && this.carTypesByService) {
        const dirSlug = this.choosenDirSlug !== 'wash' ? 'tyre' : this.choosenDirSlug
        let selectedTypes = this.carTypesByService.filter(carType => carType.service.slug === dirSlug)
        // if (!selectedTypes) selectedTypes = this.carTypes[0]
        return selectedTypes
      } else {
        return []
      }
    },
    icon () {
      return this.$store.state.imgs.icon
    },
    discount () {
      return 0 //(this.$store.state.clientIdentify.client.discount.value + this.$store.state.clientIdentify.client.additional_discount.value) * 100
    },
    showActive () {
      let active = []
      const wheelsName = [ 'forwardLeft', 'forwardRight', 'backLeft', 'backRight', 'spareLeft', 'spareRight' ]
      const wheelsNameRus = [ 'Переднее левое', 'Переднее правое', 'Заднее левое', 'Заднее правое', 'Запасное левое', 'Запасное правое' ]
      wheelsName.forEach((key,index) => {
        if (this.$store.state[this.source].wheels[key] && this.$store.state[this.source].wheels[key].isActive) {
          active.push({name: wheelsNameRus[index], data: this.$store.state[this.source].wheels[key]})
        }
      })
      return active
    },
    tabs () {
      let res = [];
      const icons = ['fl', 'fr', 'bl', 'br', 'sl', 'sr'];
      let i = 0;
      for (const key in this.wheels) {
        if (this.wheels[key]) {
          res.push({key: key, icon: icons[i], slot: icons[i]})
        }
        i++;
      }
      return res
    },
    storagePeriod: {
      get() {
        return this.$store.state[this.source].storagePeriod
      },
      set(value) {
        this.$store.commit(this.source + '/setStoragePeriod', value)
      }
    },
    seal: {
      get() {
        return this.$store.state[this.source].seal
      },
      set(value) {
        this.$store.commit(this.source + '/setSeal', value)
      }
    },
    licensePlate: {
      get() {
        return this.$store.state[this.source].licensePlate
      },
      set(value) {
        this.$store.commit(this.source + '/setLicensePlate', value)
      }
    },
    name: {
      get() {
        return this.$store.state[this.clientSource].client.customer.name
      },
      set(value) {
        this.$store.commit(this.clientSource + '/setName', value)
      }
    },
    surname: {
      get() {
        return this.$store.state[this.clientSource].client.customer.surname
      },
      set(value) {
        this.$store.commit(this.clientSource + '/setSurname', value)
      }
    },
    QRcodeUrl() {
      return this.$store.state.tireStorage.QRcodeUrl
    },
    wheels: {
      get() {
        return {
          forwardLeft: this.$store.state[this.source].wheels.forwardLeft.isActive,
          forwardRight: this.$store.state[this.source].wheels.forwardRight.isActive,
          backLeft: this.$store.state[this.source].wheels.backLeft.isActive,
          backRight: this.$store.state[this.source].wheels.backRight.isActive,
          spareLeft: this.$store.state[this.source].wheels.spareLeft.isActive,
          spareRight: this.$store.state[this.source].wheels.spareRight.isActive
        }
      },
      set(value) {
        this.$store.dispatch(this.source + '/changeActiveWheels', value)
      }
    },
    isFirstTab: {
      get() {
        return this.$store.state[this.source].isFirstTab
      },
      set(value) {
        this.$store.commit(this.source + '/setIsFirstTab', value )
      }
    },

  },
  data() {
    return {
      showAllMarks: false,
      chosenItemId: null,
      chosenModel: '',
      chosenMark: '',
      carModelSSModal: false,
      filter: '',
      rules: {
        phoneNumber: [],
        name: [],
        email: []
      },
      nameRules: [
        v => !!v || 'необходимо заполнить',
      ],
      sealRules: [
        v => !!v || 'необходимо заполнить',
        v => (v && (v.length >= 4) && (v.length <= 6)) || 'Пломба должна быть от 4 до 6 цифр',
      ],
      phoneNumber: [
        v => !!v || 'необходимо заполнить',
        v => (v && (v.length == 17)) || 'Введите все цифры номера',
      ],
      licensePlateRules: [
        v => !!v || 'необходимо заполнить',
        v => (v &&v.length >=6 ) || 'Номер минимум 6 символов',
      ],
      valid: true,
      lazy: false,
      storePhone: '',
      storeFamily: '',
      storeName: '',
      allValues: [],
      totalPriceFull: 0,
      source: 'tireStorage',
      clientSource: 'clientIdentify',
      tab: null,
      myInputModel: '',
      dropped: true,
      focusedOnNumpad: false,
    }
  },
  methods: {
    chooseCarItem(val) {
      console.log(val)
      if (!this.chosenMark) {
        this.chosenMark = val.name
        this.loadModels(val.name, val.id)
      } else if (this.chosenMark) {
        this.setCarType([val.type, val.name])
        this.$store.commit('updateChosenCarId', val.id)
        setTimeout(() => {
          this.hide()
        }, 100)
      }
      // this.setCarType([item.car_type_id, item.model])
      // this.hide()
    },
    loadModels(carMark, id) {
      this.$store.commit('updateCarModels', {})
      this.filter = carMark + ' '
      this.chosenMark = carMark
      this.$store.dispatch('fetchCarModels', id)
      this.$nextTick(() => {
        if (this.$refs.filter) {
          this.$refs.filter.focus()
        }
      })
    },
    morph(int, array) {
      return (array = array || ['месяц', 'месяца', 'месяцев']) && array[(int % 100 > 4 && int % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(int % 10 < 5) ? int % 10 : 5]];
    },
    changeLetters(str) {
      const replace = ["й","ц","у","к","е","н","г","ш","щ","з","х","ъ",
          "ф","ы","в","а","п","р","о","л","д","ж","э",
          "я","ч","с","м","и","т","ь","б","ю"];
      const search = ["q","w","e","r","t","y","u","i","o","p","\\[","\\]",
          "a","s","d","f","g","h","j","k","l",";","'",
          "z","x","c","v","b","n","m",",","\\."];

      for (let i = 0; i < replace.length; i++) {
        let reg = new RegExp(replace[i], 'mig');
        str = str.replace(reg, function (a) {
          return a && a === a.toLowerCase() ? search[i] : search[i].toUpperCase();
        })
      }
      return str
    },
    check () {
      if(this.filter.length>0){
        let filter = this.filter
        if (this.chosenMark && this.chosenMark.length>0){
          filter = filter.replace(this.chosenMark, '')
          filter = filter.replace(' ', '').trim()
          if (filter.length > 1) {
            if(this.carModelsFiltred.length===1){
              this.setCarType([this.carModelsFiltred[0].car_type_id, this.carModelsFiltred[0].model])
              this.hide()
              this.$refs.filter.blur()
            }
            this.carModels.forEach((x)=>{
              if( x.model && filter && x.model.toLowerCase() === filter.toLowerCase()) {
                if(filter.length === x.model.length)
                {
                  this.setCarType([x.car_type_id, x.model])
                  this.hide()
                  this.$refs.filter.blur()
                }
              }
            })
          }
        } else {
          if (filter && filter.length > 1) {
            if(this.carMarksFiltred.length===1){
              this.loadModels(this.carMarksFiltred[0].mark)
              this.hide()
              this.$refs.filter.blur()
            }
            this.carMarks.forEach((x)=>{
              if( x.mark.toLowerCase() === filter.toLowerCase()) {
                if(this.filter.length === x.mark.length)
                {
                  this.loadModels(x.mark)
                  this.hide()
                  this.$refs.filter.blur()
                }
              }
            })
          }
          console.log('2',this.filter.length)
        }

      } else {
        this.chosenMark = null
        this.chosenModel = null
      }
    },
    clearMark() {
      this.filter = ''
      this.chosenMark = null
      this.chosenModel = null
    },
    checkFilter () {
      // костыль чтобы успеть нажать кнопку
      setTimeout(()=>{
        // let tempfilter = this.filter.split(' ')
        const tempMark = this.chosenMark && this.chosenMark.length > 0 ? this.filter.substr(0,this.chosenMark.length) : false
        const tempModel = this.chosenModel && this.chosenModel.length > 0 ? this.filter.substr(this.chosenMark.length+1,this.chosenModel.length) : false
        if (tempMark && tempMark == this.chosenMark){
          if (tempModel && tempModel !== this.chosenModel) {
            this.filter = this.chosenMark + ' '
            this.chosenModel = ''
            this.carType = ''
          }
        } else {
          this.clearMark()
        }
      },100)
    },
    // loadModels(carMark) {
    //   this.filter = carMark
    //   this.chosenMark = carMark
    //   this.$store.dispatch('fetchCarModels', carMark)
    //   //this.$nextTick(() => {
    //   //    this.$refs.filter.focus()
    //   //})
    // },
    // setCarType([carTypeId, carModel]) {
    //   this.filter = this.chosenMark + ' ' + carModel
    //   this.chosenModel = carModel
    //   this.$store.commit('updateCarType', carTypeId)
    // },
    setCarType([carTypeId, carModel]) {
      this.filter = this.chosenMark + ' ' + carModel
      this.chosenModel = carModel
      const carTypeIndex = this.filtrCarTypes.findIndex(t => carTypeId.some((ct => ct.slug === t.slug)))
      this.$store.commit('updateCarType', carTypeIndex+1)
      this.$store.commit('updateCarTypeArr', carTypeId)
    },
    loadCarDetails(car) {
      this.filter = car.mark + ' ' + car.model
      this.chosenMark = car.mark
      this.chosenModel = car.model
      this.carType = car.car_type_id
      this.client.plate = car.pivot.plate_number
      this.client.car_id = car.pivot.id
      this.chosenPlate = car.pivot.plate_number
    },
    addClientCar() {
      this.$store.dispatch('addClientCar', {'carMark': this.chosenMark, 'carModel': this.chosenModel, 'plate_number': this.plate, 'userId': this.client.id })
    },
    show () {
      this.carModelSSModal=true;
      this.$nextTick(() => {
        this.$refs.filter.focus()
      })
    },
    hide () {
      this.carModelSSModal=false;
    },
    shortSidename(sideName){
      const wheelsName = [ 'ПЛ', 'ПП', 'ЗЛ', 'ЗП', 'ЗАП1', 'ЗАП2' ]
      const wheelsNameRus = [ 'Переднее левое', 'Переднее правое', 'Заднее левое', 'Заднее правое', 'Запасное левое', 'Запасное правое' ]
      let index = wheelsNameRus.findIndex(x=>x==sideName)
      return wheelsName[index]

    },
    numberWithSpaces(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }
    },
    getTotalWheelsInfo (value) {
      let allValues = []
      value.forEach((x) => {
        if(x.data.isActive) {
          const sidename = x.name
          x = x.data.data
          x.side = this.shortSidename(sidename)
          x.quantity = 1
          let text = 'R' + x.radius + '.'
          if (x.isTire) {
            text = text + ' резина '
                + this.$store.state[this.source].seasons[x.tireSeason] + ' '
            if (x.tireMark) {
              text = text + ' ' + x.tireMark
            }
            if (x.tireState || x.tireWidth || x.tireHeight || x.tireProfile) {
              text = text + ', '
            } else {
              text = text + '.'
            }
            if (x.tireState) text = text + 'состояние ' + x.tireState.toLowerCase() + ', '
            if (x.tireWidth) text = text + 'ширина ' + x.tireWidth + ' мм, '
            if (x.tireHeight) text = text + 'высота ' + x.tireHeight + ', '
            if (x.tireProfile) text = text + 'протектор ' + x.tireProfile + ' мм.'
          } else {
            text = text + ' Резина отсутствует.'
          }
          if (x.isWheelDisk) {
            const dtype = x.solidDisk ? 'литой' : 'штампованый'
            text = text + ' Диск '
                + dtype + ', колпачок '
                + this.$store.state[this.source].cap[x.hubcap] + ', состояние '
                + x.wheelDiskState.toLowerCase() + '.'
          } else {
            text = text + ' Без дисков.'
          }
          if(allValues.length>0){
            const i = allValues.findIndex(val => val.text == text)
            if (i>=0) {
              x.side =allValues[i].item.side + ',' + x.side
              x.quantity = 1
              allValues.splice(i, 1, { text, item: x })
            } else {
              allValues.push({ text, item: x })
            }
          } else {
            allValues.push({ text, item: x })
          }
        }
      })
      const ci = this.avPeriodsService.find(item => item.id === this.chosenItemId)
      this.totalPriceFull = ci.price
      // if(this.storagePeriod===0){
      //     this.totalPriceFull = 2000
      // } else {
      //     this.totalPriceFull = 3000
      // }
      // const serviceIndex = this.$store.getters.services.findIndex(v => v.id === this.itemID)
      // this.$store.commit('updateServicesPrice', [serviceIndex ,this.totalPriceFull])
      this.allValues = allValues
      return allValues
    },
    addServiceToCart() {
      const wheel = this.showActive[0]
      if (this.$refs.form.validate()&&((wheel.tireWidth&&wheel.tireHeight&&wheel.tireMark)||!wheel.isTire)&&this.licensePlate&&this.seal){
        const service = this.$store.getters.services.find(v => v.id === this.chosenItemId)
        const ci = this.avPeriodsService.find(item => item.id === this.chosenItemId)
        let content = {tyres:[], count_tyres:0, count_disks:0, duration: ci.params.period, clientName: this.storeName, clientFamily: this.storeFamily, clientPhone: this.storePhone, car_mark: this.chosenMark }
        this.showActive.forEach((x)=>{
          x = x.data.data
          console.log('tyre:', x)
          let sizefull = x.tireWidth + '/' + x.tireHeight + ' R' + x.radius
          let tyre = {
            "type": 1,
            "mark": x.tireMark,
            "season": this.$store.state[this.source].seasons[x.tireSeason],
            "disk_type": x.isWheelDisk ? x.solidDisk ? 'Литой' : 'Штампованый' : null ,
            "disk_cap": x.hubcap,
            "size": x.isTire?sizefull:x.radius,
            "protector": x.tireProfile?x.tireProfile:null,
            "cover": 0
          }
          content.tyres.push(tyre)
          content.count_tyres++
          x.isWheelDisk ? content.count_disks++ : ''
        })
        content = Object.assign({}, content)
        let storagePeriod = this.storagePeriod
        this.$store.dispatch('addServiceToCart', {
          'service': service,
          'client': this.$store.getters.client,
          'storeClient': {
            phone: this.storePhone,
            name: this.storeName,
            surname: this.storeFamily,
            carMark: this.chosenMark,
            carModel: this.chosenModel,
          },
          'quantity': 1,
          'params': {
            seal: this.seal,
            licensePlate: this.licensePlate,
            storagePeriod: storagePeriod,
            text: this.allValues[0].text,
            content:content,
            description: ci.params.period + ' ' + this.morph(ci.params.period)
          },
          'price': this.totalPriceFull
        })
      } else {
        const inputsRefLocal = inputsRef.map(item => this.$refs[item])
        const inputsRefTireForm = tireFormInputsRef.map(item => this.$refs.TireForm[0].$refs[item])
        const inputs = [...inputsRefLocal, ...inputsRefTireForm]
        const inputsHaveError = inputs.filter(item => item.hasError)
        const inputsHaveErrorHeight = inputsHaveError.map(item => item.$el.getBoundingClientRect().top)
        const headerHeight = document.querySelector('header').clientHeight
        const heightPositionsInputErrorWithOutPlus = inputsHaveErrorHeight.filter(el => el < headerHeight)

        if (heightPositionsInputErrorWithOutPlus.length) {
          const minHeight = Math.min.apply(null, heightPositionsInputErrorWithOutPlus)
          this.$emit('scrollTo', minHeight)
        }
      }

    },
    toggleStoragePeriod(value) {
      this.$store.commit('setStoragePeriod', value)
    },
    onTabChange () {
      if(this.isFirstTab) {
        this.$store.dispatch('copySide', this.tabs[0].slot)
      }
      this.isFirstTab = false;
    },
    blurNumpad() {
      this.focusedOnNumpad = false
    },
  },
  created() {
    this.$store.dispatch(this.source +'/init')
    this.$store.dispatch(this.source +'/getTireMarks')
    if(Object.keys(this.carMarks).length === 0) this.$store.dispatch('fetchCarMarks')
    if(this.$store.state.clientCard.chosenMark && this.$store.state.clientCard.chosenModel) {
      this.filter = this.$store.state.clientCard.chosenMark + ' ' + this.$store.state.clientCard.chosenModel
      this.chosenMark = this.$store.state.clientCard.chosenMark
      this.chosenModel = this.$store.state.clientCard.chosenModel
    }
    this.storePhone = this.$store.state[this.clientSource].client.customer.phone || ''
    this.storeName = this.$store.state[this.clientSource].client.customer.name || ''
    this.storeFamily = this.$store.state[this.clientSource].client.customer.surname || ''
    this.isFirstTab = true

    this.seal = ''
    this.licensePlate = ''
    this.storagePeriod = 1
    this.chosenItemId = this.itemID
  }
}
</script>
<style>
.carmark{
  width: 10vw;
}
</style>
